const blocos = {
	wpBlockImage: function (target = document.body) {
		$('.wp-block-image', target)
			.attr('class', function () {
				if ($(this).hasClass('text-start')) {
					return 'text-start';
				}
				return 'text-center';
			})
			.find('img')
			.attr('class', 'img-fluid img-thumbnail')
			.wrap(function () {
				if (
					$(this).parent().find('.lightbox-trigger').remove().length
				) {
					$('.wp-lightbox-overlay').remove();
					return $('<a>').attr('href', $(this).attr('src'));
				}
				return;
			});
	},
	wpBlockTable: function (target = document.body) {
		$('.wp-block-table', target)
			.attr('class', 'table-responsive w-100')
			.find('table')
			.attr('class', 'table table-bordered table-striped table-hover')
			.find('thead,tfoot')
			.find('td,th')
			.attr('class', 'fw-bold');
	},
	wpElementCaption: function (target = document.body) {
		$('.wp-element-caption', target)
			.attr('class', 'text-center small fw-bold fst-italic')
			.text(function () {
				return $(this).text();
			});
	},
	wpBlockGallery: function (target = document.body) {
		$('.wp-block-gallery', target)
			.attr('class', 'swiper-wrapper')
			.wrap('<div class="swiper">')
			.after(
				'<div class="swiper-pagination"></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div>'
			)
			.find('figure')
			.attr('class', 'swiper-slide text-center');

		$(document).trigger('update.swiper', target);
	},
	wpBlockQuote: function (target = document.body) {
		$('.wp-block-quote', target).attr(
			'class',
			'blockquote border-start border-3 ps-3'
		);
	},
	wpElementButton: function (target = document.body) {
		$('.wp-element-button', target).attr(
			'class',
			'btn btn-sm btn-outline-primary m-1'
		);
	},
	wpBlockFile: function (target = document.body) {
		$('object[type="application/pdf"][data$=".pdf"]', target)
			.filter(function () {
				return document.location.origin === new URL(this.data).origin;
			})
			.replaceWith(function () {
				return $('<iframe>').attr({
					src: $(this).attr('data'),
					style: $(this).attr('style'),
					loading: 'lazy',
				});
			});

		$(document).trigger('update.pdf', target);
	},
	migracao: function (target = document.body) {
		$('[itemprop="articleBody"] img:not(.img-fluid)', target)
			.addClass('img-fluid img-thumbnail')
			.wrap('<div class="text-center"></div>')
			.removeAttr('align');
		$('[itemprop="articleBody"] table:not(.table)', target)
			.addClass('table table-bordered table-striped table-hover')
			.wrap('<div class="table-responsive w-100"></div>');
	},
};

document.addEventListener('DOMContentLoaded', () =>
	jQuery(($) =>
		$(document)
			.on('update.blocos', (e, target = document.body) =>
				Object.values(blocos).forEach((fn) => fn(target))
			)
			.trigger('update.blocos')
	)
);
